import { render, staticRenderFns } from "./BlogPartnershipTable.vue?vue&type=template&id=750457c5"
import script from "./BlogPartnershipTable.vue?vue&type=script&lang=js"
export * from "./BlogPartnershipTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports